




























































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import i18n from "@/lang/i18n";
import { SearchService } from "@/services/SearchService";
import {
  getStoreId,
  getMultiStoreId,
  getTenantId
} from "@/services/AuthService";

interface SelectOption {
  label: string;
  value: any;
}

@Component({})
export default class SearchSelectMinimal extends Vue {
  @Prop({ required: true }) filter!: any;
  @Prop({ default: () => ({}) }) search!: any;
  @Prop({ default: "" }) context!: string;

  @Prop() model!: any;
  @Prop() modellabel!: any;
  @Prop() operation!: string;

  options: SelectOption[] = [];
  selectedOption: SelectOption | null = null;
  selectedOptions: SelectOption[] = [];
  loading = false;

  created() {
    if (this.operation === undefined || this.operation === null) {
      this.$emit("update:operation", "=");
    }

    if (this.isStatic) {
      this.initStaticOptions();
    } else if (this.isAutocomplete && !this.hasDontLoadOnStart) {
      this.load();
    }
  }

  get isMultiple() {
    return (
      this.filter.type === "CHOOSE_ANY" ||
      this.filter.type === "CHOOSE_ANY_INTEGER"
    );
  }

  get isAutocomplete() {
    return (
      this.filter.typeSpec &&
      typeof this.filter.typeSpec === "string" &&
      this.filter.typeSpec.startsWith("autocomplete:")
    );
  }

  get isStatic() {
    return (
      this.filter.typeSpec &&
      typeof this.filter.typeSpec === "string" &&
      !this.filter.typeSpec.startsWith("autocomplete:")
    );
  }

  get hasDontLoadOnStart() {
    return (
      this.filter.typeSpec &&
      this.filter.typeSpec.indexOf("&dontLoadOnStart=true") !== -1
    );
  }

  get hasRemoteSearch() {
    if (!this.isAutocomplete) return false;
    const spec: string = this.filter.typeSpec;
    if (spec.indexOf("&hasRemote=true") !== -1) return true;
    if (spec.indexOf("&dontLoadOnStart=true") !== -1) return true;
    return false;
  }

  get fieldLabel() {
    if (this.filter.display && this.filter.display !== "") {
      return this.$t(this.filter.display) as string;
    }
    return this.$t(this.filter.field) as string;
  }

  initStaticOptions() {
    const spec: string = this.filter.typeSpec || "";
    const rawValues = spec ? spec.split("|") : [];

    this.options = rawValues.map((v: string) => {
      const label: any = v;
      return {
        label: i18n.t(label) as string,
        value: v
      };
    });

    if (!this.isMultiple) {
      const defVal = this.filter.defaultValue ?? this.model;
      if (defVal != null) {
        const found = this.options.find(
          o => String(o.value) === String(defVal)
        );
        if (found) {
          this.selectedOption = found;
          this.emitSingle(found);
        }
      }
    } else {
      const defVals: any[] = this.model || [];
      if (Array.isArray(defVals) && defVals.length > 0) {
        const found = this.options.filter(o =>
          defVals.map(String).includes(String(o.value))
        );
        this.selectedOptions = found;
        this.emitMultiple(found);
      }
    }
  }

  processUrl(): string {
    let url = (this.filter.typeSpec as string)
      .replace("autocomplete:", "")
      .replace("{storeId}", getStoreId())
      .replace("{STORE_ID}", getStoreId())
      .replace("{MULTISTORE_ID}", getMultiStoreId());

    Object.keys(this.search || {}).forEach(key => {
      const fullKey = `{${key}}`;
      const condKey = `{STORE_ID_IF_TRUE(${key})}`;

      if (url.includes(fullKey)) {
        url = url.replace(fullKey, this.search[key]);
      }
      if (url.includes(condKey)) {
        const val = this.search[key] === true ? getStoreId() : "";
        url = url.replace(condKey, val);
      }
    });

    return url;
  }

  mapListValues(url: string) {
    if (url.indexOf("/claim/status/categories") !== -1) {
      return {
        labelName: "description",
        valueName: "code",
        pathName: null,
        translate: { template: "code" }
      };
    }
    if (url.indexOf("/claim/status") !== -1) {
      return {
        labelName: "description",
        valueName: "description",
        pathName: null
      };
    }
    if (url.indexOf("/auth-registry/users/search") !== -1) {
      return { labelName: "username", valueName: "id", pathName: "content" };
    }
    if (url.indexOf("/customers") !== -1) {
      return {
        labelName: "businessName",
        valueName: "customerId",
        pathName: "content"
      };
    }
    if (url.indexOf("/pricelist/configuration/mbe-services") !== -1) {
      return {
        labelName: "mbeServiceName",
        valueName: "idMBEBusiness",
        pathName: null
      };
    }
    if (url.indexOf("/pricelist/configuration/couriers?") !== -1) {
      return {
        labelName: "courierName",
        valueName: "idMBEBusiness",
        pathName: null
      };
    }
    if (
      url.indexOf("/pricelist/configuration/courier-services-bycourier") !== -1
    ) {
      return {
        labelName: "courierServiceName",
        valueName: "idBusiness",
        pathName: null
      };
    }
    if (url.indexOf("/tenants/countries") !== -1) {
      return {
        labelName: "name",
        valueName: "id",
        pathName: null,
        translate: { template: "country_${0}", valueName: "id" },
        sort: true
      };
    }

    return { labelName: "label", valueName: "value", pathName: null };
  }

  async load(searchStr?: string) {
    const url = this.processUrl();
    this.loading = true;

    try {
      const { labelName, valueName, pathName, translate } = this.mapListValues(
        url
      );

      const params: any = {};
      let methodType: "GET" | "POST" = "GET";
      let data: any = undefined;

      if (searchStr && this.hasRemoteSearch) {
        params.search = searchStr;
      }

      if (url.includes("auth-registry/users/search")) {
        methodType = "POST";
        data = {
          tenantId: getTenantId(),
          multistoreId: getMultiStoreId(),
          storeId: getStoreId(),
          username: searchStr || "",
          authRoleTypes: ["STORE_USER", "STORE_ADMIN"],
          includeInactive: false
        };
      }

      const res: any = await SearchService.getMetadataInfo(
        url,
        params,
        methodType,
        data
      );
      let dataArr = pathName ? res[pathName] : res;

      if (!Array.isArray(dataArr)) {
        if (res && Array.isArray(res.content)) {
          dataArr = res.content;
        } else {
          dataArr = [];
        }
      }

      this.options = dataArr.map((el: any) => {
        let label = el[labelName];
        if (translate) {
          if (translate.valueName) {
            const translationKey = translate.template.replace(
              "${0}",
              el[translate.valueName]
            );
            label = i18n.t(translationKey);
          } else {
            label = i18n.t(el[translate.template]);
          }
        }
        return {
          label,
          value: el[valueName]
        };
      });

      if (!this.hasRemoteSearch) {
        this.loadDefVals();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  loadDefVals() {
    if (!this.isMultiple) {
      const defVal = this.filter.defaultValue ?? this.model;
      if (defVal != null) {
        const found = this.options.find(
          o => String(o.value) === String(defVal)
        );
        if (found) {
          this.selectedOption = found;
          this.emitSingle(found);
        }
      }
    } else {
      const defVals: any[] = this.model || [];
      if (Array.isArray(defVals) && defVals.length > 0) {
        const found = this.options.filter(o =>
          defVals.map(String).includes(String(o.value))
        );
        this.selectedOptions = found;
        this.emitMultiple(found);
      }
    }
  }

  handleSearch(query: string) {
    if (!query || query.length < 3) return;
    this.load(query.toLowerCase());
  }

  onChangeSingle(opt: SelectOption | null) {
    if (!opt) {
      this.emitSingle(null);
      return;
    }
    this.emitSingle(opt);
  }

  onChangeMultiple(opts: SelectOption[]) {
    this.emitMultiple(opts || []);
  }

  emitSingle(opt: SelectOption | null) {
    const value = opt ? opt.value : null;
    const label = opt ? opt.label : null;
    this.$emit("update:model", value);
    this.$emit("update:modellabel", label);
  }

  emitMultiple(opts: SelectOption[]) {
    const values = opts.map(o => o.value);
    const labels = opts.map(o => o.label);
    this.$emit("update:model", values.length ? values : null);
    this.$emit("update:modellabel", labels.length ? labels : null);
  }
}
